import {observable} from 'mobx'
import autobind from 'autobind-decorator'

class NavigationStore {
    @observable location = null;

    constructor(history) {
        this.history = history
    }

    @autobind push(location) {
        this.history.push(location);
    }

    @autobind replace(location) {
        this.history.replace(location);
    }

    @autobind go(n) {
        this.history.go(n);
    }

    @autobind goBack() {
        this.history.goBack();
    }

    @autobind goForward() {
        this.history.goForward();
    }
}


export default NavigationStore;